import { RadioGroup, styled } from '@mui/material';

export const StyledRadioGroup = styled(RadioGroup)`
  hr:last-child {
    display: none;
  }
`;
